<template>
  <div id="tab2" class="tab-panel">
    <div class="row">
      <div class="col-md-12">
        <!-- Main Form -->
        <div class="login-form-1">
          <form v-if="hash" id="login-form-2" action="#">
            <h3 class="text-center no-margin-top">Придумай пароль</h3>
            <p class="mar-bot-25 text-center">
              Этот пароль будет использоваться для входа в учетную запись
            </p>
            <div class="main-login-form text-left">
              <div class="login-group">
                <div class="form-group">
                  <input
                    disabled
                    :value="email"
                    name="email"
                    type="email"
                    class="form-control"
                    id="lg_password"
                    placeholder="Email"
                  />
                </div>
                <div class="form-group">
                  <input
                    autocomplete="off"
                    @input="keypress"
                    name="password"
                    type="password"
                    class="form-control"
                    id="lg_password"
                    placeholder="Password"
                  />
                </div>
              </div>
              <button
                v-if="!loading"
                @click="restoreUserPassword"
                type="button"
                class="login-button"
              >
                <i class="fa fa-chevron-right"></i>
              </button>
            </div>
          </form>
          <form id="login-form-2" action="#" v-else>
            <h3 class="text-center no-margin-top">Неверный хэш</h3>
            <p class="mar-bot-25 text-center">
              Возможно ты воспользовался устаревшей ссылкой или пароль был
              восстановлен ранее.
            </p>
            <div class="etc-login-form text-center text-main">
              <p @click="routeAuth" class="mar-top-15 no-margin-bottom">
                <a><b>Войти</b></a>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  props: ["loading"],
  computed: {
    ...mapState("user", ["data"]),
    ...mapState("app", {
      email: state => state.auth.email,
      hash: state => state.auth.hash
    }),
    query() {
      return this.$route.query.hash;
    }
  },
  methods: {
    ...mapActions("app", ["authCheckHash"]),
    ...mapActions("user", ["restoreUserPassword"]),
    keypress(ev) {
      this.$emit("handleInput", ev);
    },
    routeAuth() {
      this.$router.push({ name: "auth" });
    },
    hashExist() {
      return this.query !== null;
    }
  },
  mounted() {
    if (this.query) this.authCheckHash(this.query);
  }
};
</script>
